import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

export default () => {
  const [activeTab, setActiveTab] = useState("adv");
  const data = useStaticQuery(graphql`
    query LinkSkills {
      allLinkSkillsCsv {
        nodes {
          order
          class
          description
          lvl70
          lvl120
        }
      }
    }
  `);

  function switchTab(order) {
    setActiveTab(order);
  }

  const linkSkillNodes = data.allLinkSkillsCsv.nodes;
  return (
    <div>
      <h4 className="title">Link Skills Table</h4>
      <div className="tabs is-fullwidth">
        <ul>
          <li
            className={`${activeTab === "adv" ? "is-active" : ""}`}
            onClick={() => switchTab("adv")}
          >
            <a>Adventurer</a>
          </li>
          <li
            className={`${activeTab === "hero" ? "is-active" : ""}`}
            onClick={() => switchTab("hero")}
          >
            <a>Hero</a>
          </li>
          <li
            className={`${activeTab === "koc" ? "is-active" : ""}`}
            onClick={() => switchTab("koc")}
          >
            <a>Knight of Cygnus</a>
          </li>
          <li
            className={`${activeTab === "res" ? "is-active" : ""}`}
            onClick={() => switchTab("res")}
          >
            <a>Resistance</a>
          </li>
        </ul>
      </div>
      <div className="table-container">
        <Table className="table is-hoverable">
          <Thead>
            <Tr>
              <Th>Class</Th>
              <Th>Description</Th>
              <Th>Lvl70</Th>
              <Th>Lvl120</Th>
            </Tr>
          </Thead>
          <Tbody>
            {linkSkillNodes.map((node, index) => {
              if (node.order !== activeTab) return;
              return (
                <Tr key={index}>
                  <Td>{node.class}</Td>
                  <Td>{node.description}</Td>
                  <Td>{node.lvl70}</Td>
                  <Td>{node.lvl120}</Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </div>
    </div>
  );
};
